var map = {
	"./01_limit.json": "WMCK",
	"./02_connect.json": "Jf00",
	"./03_data_compress.json": "eQk0",
	"./04_heart_beat.json": "nCmZ",
	"./05_subscribe.json": "D11h",
	"./06_cancel_subscribe.json": "8PHc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZuZg";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/introduce \.json$
// module id = ZuZg
// module chunks = 3